import { render, staticRenderFns } from "./FurnitureSelector.vue?vue&type=template&id=802ee600&scoped=true&"
import script from "./FurnitureSelector.vue?vue&type=script&lang=js&"
export * from "./FurnitureSelector.vue?vue&type=script&lang=js&"
import style0 from "./FurnitureSelector.vue?vue&type=style&index=0&id=802ee600&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "802ee600",
  null
  
)

export default component.exports